import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/classificationByOrigins'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'classificationByOrigins'

export const metadata = {
  icon: 'leaf',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const ClassificationByOriginsListPage = createListPage({ metadata, api, actionCreators, Content })
const ClassificationByOriginsDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { ClassificationByOriginsListPage, ClassificationByOriginsDetailPage }
